// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 7775) return "css/Template2.a1de7a34-64db-43f1-ba8f-9491c389ecc3.chunk.css";
	if (chunkId === 628) return "css/Template3.a1de7a34-64db-43f1-ba8f-9491c389ecc3.chunk.css";
	if (chunkId === 9245) return "css/MobileTemplate1.a1de7a34-64db-43f1-ba8f-9491c389ecc3.chunk.css";
	if (chunkId === 2437) return "css/aiAgentV2.a1de7a34-64db-43f1-ba8f-9491c389ecc3.chunk.css";
	if (chunkId === 7866) return "css/aiAgent.a1de7a34-64db-43f1-ba8f-9491c389ecc3.chunk.css";
	if (chunkId === 1399) return "packages/reactflow@11.8.3/reactflow.a1de7a34-64db-43f1-ba8f-9491c389ecc3.bundle.css";
	if (chunkId === 4149) return "packages/@wangeditor@5.0.1/@wangeditor.a1de7a34-64db-43f1-ba8f-9491c389ecc3.bundle.css";
	if (chunkId === 3339) return "packages/icp-mining@2.1.2/icp-mining.a1de7a34-64db-43f1-ba8f-9491c389ecc3.bundle.css";
	if (chunkId === 8309) return "css/saas-ui-chat.a1de7a34-64db-43f1-ba8f-9491c389ecc3.chunk.css";
	if (chunkId === 5299) return "packages/icp-form-designer@2.1.2/icp-form-designer.a1de7a34-64db-43f1-ba8f-9491c389ecc3.bundle.css";
	// return url for filenames based on template
	return undefined;
};